// 解决安卓端字体大小 不跟随系统变化的问题
// 如果 eslint 报错 说 WeixinJSBridgeReady 不存在
// globals: { wx: true,WeixinJSBridge:true },
;(function() {
    if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
        handleFontSize()
    } else {
        document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
    }
    function handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function() {
            WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
        })
    }
})()

// webview.getSettings().setTextZoom(100);
// WebView加上这个设置后,WebView里的字体就不会随系统字体大小设置发生变化了.

//  /* ios 限制微信更改字体大小 */
// -webkit-text-size-adjust: 100% !important;



// WEBPACK FOOTER //
// ./src/util/font-rem.js